document.addEventListener('DOMContentLoaded', () => {
    const historySwiper = new Swiper('.history-swiper', {
		loop: true,
		slidesPerView: 1,
		speed: 800,
        effect: "fade",
		fadeEffect: {
			"crossFade": true
		},
		navigation: {
			nextEl: ".history-next",
			prevEl: ".history-prev",
		}
	});

	const reviewsSwiper = new Swiper('.reviews-swiper', {
		loop: true,
		slidesPerView: 1,
		speed: 800,
        effect: "fade",
		fadeEffect: {
			"crossFade": true
		},
		navigation: {
			nextEl: ".reviews-next",
			prevEl: ".reviews-prev",
		}
	});

	const gallerySwiper = new Swiper('.gallery-swiper', {
		loop: true,
		slidesPerView: 1,
		speed: 800,
        effect: "fade",
		fadeEffect: {
			"crossFade": true
		},
		autoplay: {
			delay: 2800,
		}
	});

	const cardsSwiper = new Swiper('.cards-swiper', {
		loop: true,
		slidesPerView: 1,
		speed: 800,
		navigation: {
			nextEl: ".cards-next",
			prevEl: ".cards-prev",
		}
	});

});